import React from 'react'
import { PropTypes } from 'prop-types'
import {
  Alert as FableAlert, Button, Card as FableCard, Link as FableLink
} from '@sainsburys-tech/fable'
import { ChevronRight } from '@sainsburys-tech/icons'
import WithFooter from '../../Footer'
import FooterWithButton from '../../Footer/FooterWithButton'
import api from '../../../utils/api'
import Title from '../../PageTitle'
import DeletePassModal from '../DeletePassModal'
import LoadingOverlay from '../../LoadingOverlay'
import { visitPassActionTypes } from '../../../utils/constants'


const NoPassRequired = -1

class Passes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      modalPass: {
        id: null,
        name: ''
      },
      loading: true
    }
  }

  componentWillMount = () => {
    const {
      setHeaderBurger,
      setSignOutHeader,
    } = this.props

    setHeaderBurger()
    setSignOutHeader(true)
    this.getPasses()

    window.scrollTo(0, 0)
  }

  getPasses = () => {
    const { setPassTypes, site } = this.props

    api.getPasses(site.siteType).then((response) => {
      setPassTypes(response)
      this.setState({ loading: false })
    })
  }

  handleSelectPass = (pass) => {
    if (!this.isPassSelected(pass)) {
      const { history, setVisitPass } = this.props
      setVisitPass(pass)
      history.push('/passquestions')
    }
  }

  handleNoPassRequired = () => {
    const { visitId, site } = this.props
    const visitPass = {
      visitId,
      passTypeId: NoPassRequired,
      siteType: site.siteType
    }
    const { history } = this.props

    api.addVisitPass(visitPass)
      .then((response) => {
        if (response !== null && response.status === 200) {
          history.push('/WorkOrderHome')
        }
      })
  }

  displayPassStatus = (pass) => {
    const passSaved = this.isPassSelected(pass)

    if (!passSaved) {
      return null
    }

    return (
      <div>
        {this.showPassAsSaved(pass)}
      </div>
    )
  }

  isPassSelected = (pass) => {
    const { visitPasses } = this.props
    if (visitPasses) {
      const index = visitPasses.map(e => e.passTypeId).indexOf(pass.id)
      return index !== -1
    }
    return false
  }

  showPassAsSaved = pass => (
    <div className="dsib-passes__savedRow">
      <FableAlert
        className="dsib-passes__savedAlert"
        status="info"
        // variant="secondary"
        isOpen
        message="Saved"
        hasStatusIcon={false}
      />

      <FableLink
        as="button"
        type="button"
        className="dsib-passes__deleteLink"
        onClick={() => this.checkDeletePass(pass)}
      >
        Delete
      </FableLink>
    </div>

  )

  checkDeletePass = (pass) => {
    this.setState({ modalOpen: true, modalPass: pass })
  }

  deletePass = (pass) => {
    const { deleteVisitPass, visitPasses } = this.props

    const passToDelete = visitPasses.find(p => p.passTypeId === pass.id)

    this.setState({ loading: true, modalOpen: false })

    api.deleteVisitPass(passToDelete).then(() => {
      deleteVisitPass(passToDelete)
      this.setState({ loading: false })
    })
  }

  sendPassesForAuthorisation = (buttonText) => {
    const {
      history, visitPasses, username, visitId
    } = this.props

    this.setState({ loading: true })

    const authorisation = {
      actionTypeId: visitPassActionTypes.submitted,
      visitPassIds: visitPasses.map(a => a.id),
      actionedOn: new Date(),
      buttonText,
      visitId
    }

    api.addVisitAction(authorisation).then((res) => {
      if (res) {
        history.push('/WorkOrderHome')
      }
    }).catch(() => { this.setState({ loading: false }) })
  }

  showChevron = (pass) => {
    if (!this.isPassSelected(pass)) {
      return <ChevronRight aria-hidden="true" focusable="false" />
    }
    return null
  }

  handlePassKeyDown = (event, pass) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.handleSelectPass(pass)
    }
  }

  displayPasses = () => {
    const { passTypes } = this.props

    if (passTypes) {
      return passTypes.map(pass => (
        <div className="u-margin-bottom__small" key={pass.id}>
          {this.displayPassStatus(pass)}
          <FableCard
            orientation="horizontal"
            hasBorder
            contentAlignment="left"
            className="dsib-passes__card"
            role="button"
            tabIndex={0}
            onClick={() => this.handleSelectPass(pass)}
            onKeyDown={event => this.handlePassKeyDown(event, pass)}
          >
            <FableCard.Content label={pass.name} labelSize="Display3" />
            <FableCard.Actions className="dsib-passes__cardAction">
              {this.showChevron(pass)}
            </FableCard.Actions>
          </FableCard>
        </div>
      ))
    }
    return null
  }

  getFooter = () => (
    <FooterWithButton
      button={<Button className="dsib-footerWithButton__button" variant="secondary" onClick={this.handleNoPassRequired}>I don't need a pass</Button>}
    />
  )

  getModal = () => {
    const { modalOpen, modalPass } = this.state
    return (
      <DeletePassModal open={modalOpen} pass={modalPass} acceptClicked={this.deletePass} rejectClicked={() => this.setState({ modalOpen: false })} />
    )
  }

  render() {
    const { selectedWorkOrder, visitPasses } = this.props
    const { loading } = this.state

    const sendForAuthorisationButtonText = 'Send for authorisation'

    if (visitPasses === null || visitPasses.length === 0) {
      return (
        <WithFooter footer={this.getFooter()}>
          {loading
            && <LoadingOverlay hasBackground />
          }
          <Title workOrderNumber={selectedWorkOrder} text="Select a work pass if required" />
          {this.displayPasses()}
        </WithFooter>
      )
    }

    return (
      <div>
        {loading
          && <LoadingOverlay hasBackground />
        }
        {this.getModal()}
        <Title workOrderNumber={selectedWorkOrder} text="Select another work pass if required" />
        {this.displayPasses()}
        <FableCard orientation="vertical" hasBorder className="dsib-passes__authoriseCard">
          <div className="dsib-passes__authoriseInner">
            <p className="dsib-passes__authoriseText">
              When you have finished selecting passes you must send them to the manager to authorise.
            </p>
            <Button
              className="dsib-passes__authoriseButton"
              variant="primary"
              isFullWidth
              onClick={() => this.sendPassesForAuthorisation(sendForAuthorisationButtonText)}
            >
              {sendForAuthorisationButtonText}
            </Button>
          </div>
        </FableCard>
      </div>
    )
  }
}

Passes.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  selectedWorkOrder: PropTypes.string.isRequired,
  setHeaderBurger: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  setVisitPass: PropTypes.func.isRequired,
  setPassTypes: PropTypes.func.isRequired,
  passTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  deleteVisitPass: PropTypes.func.isRequired,
  visitId: PropTypes.number.isRequired,
  visitPasses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  username: PropTypes.string.isRequired,
  site: PropTypes.shape({
    siteType: PropTypes.string.isRequired
  }).isRequired
}

Passes.defaultProps = {
  visitPasses: null,
  passTypes: []
}

export default Passes
